export function findKeyInObj(obj: any, key: string) {
  if (!key || !key.split) {
    return null;
  }
  return key.split(".").reduce((acc, cv) => {
    if (acc !== null && typeof acc !== "undefined") {
      return acc[cv];
    }
    return null;
  }, obj);
}
